import { SidebarHeader, SidebarTrigger } from '@/components/ui/sidebar';

interface SidebarHeaderSectionProps {
  isCollapsed: boolean;
  logo: string;
  onCloseMobile: () => void;
}

export default function SidebarHeaderSection({
  isCollapsed,
  logo,

  onCloseMobile,
}: SidebarHeaderSectionProps) {
  return (
    <div className="relative bg-[#FFFFFF] dark:bg-[#091327] lg:bg-[#091327]">
      <SidebarHeader className="relative pt-[2rem]">
        <div className="mx-[1.6rem] flex pb-[2rem] lg:justify-center lg:border-b lg:border-[#E2E8F0]">
          <div
            className={`w-[65%] ${isCollapsed ? 'opacity-0' : 'opacity-100'} transition-opacity`}
          >
            <img src={logo} alt="ECI Global" className="h-auto w-full" />
          </div>
        </div>

        <button
          type="button"
          aria-label="Close sidebar"
          onClick={onCloseMobile}
          className="absolute right-[1.6rem] top-[2rem] text-[#7988A4] lg:hidden"
        >
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.667 21.3334L21.3337 10.6667"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3337 21.3334L10.667 10.6667"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </SidebarHeader>

      <SidebarTrigger className="absolute left-[calc(100%_-_1.5rem)] top-1/2 hidden !h-[3rem] !w-[3rem] translate-y-[-50%] rounded-full border border-[#E2E8F0] dark:hover:border-[#1C37E0] text-[#081021] bg-[#FFFFFF] dark:hover:bg-[#1C37E0] dark:hover:text-[#FFFFFF] shadow-[0_2px_12px_0_rgba(0,0,0,0.15)] lg:flex" />
    </div>
  );
}
